import { useCallback } from 'react';

import { MenuButton, MenuButtonOption } from 'components/MenuButton/MenuButton';

export type DropdownActionProps<T> = {
  type: 'dropdown';
  label: string;
  options: Array<{ title: string; description?: string; onClick: (items: Array<T>) => void }>;
  analyticsId: string;
};

export function DropdownAction(props: { action: Omit<DropdownActionProps<any>, 'type'>; selectedItems: Array<any> }) {
  const action = useCallback(
    (action: DropdownActionProps<any>['options'][number]) => {
      action.onClick(props.selectedItems);
    },
    [props.selectedItems],
  );

  return (
    <MenuButton
      text={props.action.label}
      variant="secondary"
      analyticsId={props.action.analyticsId}
      size="base"
      className="mr-2"
    >
      {props.action.options.map((option) => {
        return (
          <MenuButtonOption
            key={props.action.analyticsId}
            onClick={() => {
              action(option);
            }}
            className="flex-col border-b border-gray-100 last:border-b-0 "
            analyticsId={props.action.analyticsId}
          >
            <div className="max-w-80 py-1 text-left">
              <p className="mb-2 text-sm font-medium text-gray-900">{option.title}</p>
              <p className="text-sm text-gray-500">{option.description}</p>
            </div>
          </MenuButtonOption>
        );
      })}
    </MenuButton>
  );
}
